import textInputModel from "../../../../models/general/elements/inputElements/textInput.model";
import TextAreaInputElementComponent from "../../../general/elements/inputElements/TextAreaInputElementComponent";
import TextInputElementComponent from "../../../general/elements/inputElements/TextInputElementComponent";

export const WebsiteConfigurationContactDetailsSection = ({ props }) => {
  const { currentValue, handleChange } = props;

  const getPhoneInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "Phone",
      value: currentValue.Phone,
      onChange: handleChange,
      label: "מספר טלפון",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getEmailInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "Email",
      value: currentValue.Email,
      onChange: handleChange,
      label: "אימייל",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getAddressInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "Address",
      value: currentValue.Address,
      onChange: handleChange,
      label: "כתובת",
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  return (
    <>
      {getPhoneInputElement()}
      {getEmailInputElement()}
      {getAddressInputElement()}
    </>
  );
};

export default WebsiteConfigurationContactDetailsSection;
